module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-500italic.f3d41e4cdcc2314e49ddcea751d6f87f.woff";